import { render, staticRenderFns } from "./ReportBuilder.vue?vue&type=template&id=16637f0a&scoped=true&"
import script from "./ReportBuilder.vue?vue&type=script&lang=js&"
export * from "./ReportBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ReportBuilder.vue?vue&type=style&index=0&id=16637f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16637f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16637f0a')) {
      api.createRecord('16637f0a', component.options)
    } else {
      api.reload('16637f0a', component.options)
    }
    module.hot.accept("./ReportBuilder.vue?vue&type=template&id=16637f0a&scoped=true&", function () {
      api.rerender('16637f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/ReportBuilder.vue"
export default component.exports